import React, { useEffect, useState } from 'react';
import { subscribeAlert } from './alertBus';
import './globalAlert.css';

function GlobalAlert() {
  const [message, setMessage] = useState('');
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const unsubscribe = subscribeAlert((msg) => {
      setMessage(msg);
      setOpen(true);
    });

    return () => unsubscribe();
  }, []);

  if (!open) {
    return null;
  }

  return (
    <div className="global-alert-backdrop" role="dialog" aria-modal="true">
      <div className="global-alert-modal">
        <div className="global-alert-message">{message}</div>
        <button
          type="button"
          className="global-alert-button"
          onClick={() => setOpen(false)}
        >
          OK
        </button>
      </div>
    </div>
  );
}

export default GlobalAlert;
